import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  extractSZLTByIdFailed,
  extractSZLTByIdSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* extractSZLTById(action) {
  try {
    if (!action.payload || !action.payload.id) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL}/proxy/backend/api/v1/registries/order-services/${action.payload.id}/extract`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    const urlProxy = data?.data?.url?.replace('https://as-taxi-external.fast.its-profit.ru/', 'https://as-taxi-external.fast.its-profit.ru/api/proxy/backend/') ?? null;
    const result = { ...data?.data };
    if (dataResponse.status === CREATED || dataResponse.status === OK) {
      yield put(extractSZLTByIdSuccessful(result));
      yield call(resolveActionPromise(action, result));
    } else {
      yield put(extractSZLTByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(extractSZLTByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
